import { fetchRequestWithTypes } from './index.js';

export const GET_ENTITLEMENTS_REQUEST = 'GET_ENTITLEMENTS_REQUEST';
export const GET_ENTITLEMENTS_SUCCESS = 'GET_ENTITLEMENTS_SUCCESS';
export const GET_ENTITLEMENTS_ERRORED = 'GET_ENTITLEMENTS_ERRORED';

export const getEntitlements = () => {
	return fetchRequestWithTypes({
		types: [GET_ENTITLEMENTS_REQUEST, GET_ENTITLEMENTS_SUCCESS, GET_ENTITLEMENTS_ERRORED],
		request: {
			method: 'GET',
			path: `/apis/customers/v1/subscriptions/entitlements`,
		},
	});
};
